"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _lang = _interopRequireDefault(require("@/lang"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _moment = _interopRequireDefault(require("moment"));

var _dateformart = require("@/utils/dateformart");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: 'rechargeOrderNotify:view',
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['auditOptions', 'informationOptions', 'orderStateOption', 'rechargeNotifyOption'])),
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      organizationOption: null,
      agentOption: null,
      total: 0,
      listLoading: true,
      timeList: [],
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        state: null,
        agentId: '',
        organizationCode: '',
        orderNo: '',
        notifyType: ""
      },
      downloadLoading: false,
      multipleSelection: []
    };
  },
  created: function created() {
    this.setDefaultTime();
    this.getList();
    this.getOption();
  },
  methods: {
    setDefaultTime: function setDefaultTime() {
      var a = new Date(Date.now());
      a.setHours(0, 0, 0, 0);
      var b = new Date(Date.now());
      b.setHours(23, 59, 59, 0);
      this.timeList = [this.dateFormat(a), this.dateFormat(b)];
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      var params = this.getQueryParams();

      _httpUtils.default.post("rechargeOrderNotify", "list", null, params).then(function (res) {
        //let index;
        _this.list = res.data.rows;
        _this.total = res.data.total;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    getOption: function getOption() {
      var _this2 = this;

      if (this.$store.getters.isAdmin) {
        _httpUtils.default.post("agent", "getAgents", null, null).then(function (agent) {
          _this2.agentOption = agent.data;
        }).catch(function (err) {
          _this2.$notify({
            title: _this2.$t("common.error"),
            message: _this2.$t("common.fetchError") + ',' + err.message,
            type: "error"
          });
        });
      }

      _httpUtils.default.post("organization", "getOrgs", null, null).then(function (res) {
        _this2.organizationOption = res.data;
      }).catch(function (err) {
        _this2.$notify({
          title: _this2.$t("common.error"),
          message: _this2.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    getQueryParams: function getQueryParams() {
      var startTime, endTime, state;

      if (!this.timeList) {
        startTime = (0, _dateformart.getYesterday)();
        endTime = (0, _dateformart.getYesterdayEnd)();
      } else {
        startTime = this.timeList[0];
        endTime = this.timeList[1];
      }

      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        startTime: startTime,
        endTime: endTime,
        state: this.queryParameter.state,
        orderNo: this.queryParameter.orderNo,
        agentId: this.queryParameter.agentId,
        organizationCode: this.queryParameter.organizationCode,
        notifyType: this.queryParameter.notifyType
      };
    },
    handleFilter: function handleFilter() {
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    handleAudit: function handleAudit(status) {
      var _this3 = this;

      var sendBoxIds = [];

      if (!this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t('warningMessage.selectRecordToAuditMessage'),
          type: 'error'
        });
      } else {
        if (status === "Approve") {
          this.$confirm(_lang.default.t('warningMessage.auditRecordConfirmMessage'), _lang.default.t('warningMessage.auditRecordMessage'), {
            confirmButtonText: _lang.default.t('common.confirm'),
            cancelButtonText: _lang.default.t('common.cancel'),
            type: 'warning'
          }).then(function () {
            for (var item in _this3.multipleSelection) {
              sendBoxIds.push(_this3.multipleSelection[item].id);
            }

            var parameter = {
              sendBoxIds: sendBoxIds,
              refuseCause: '',
              status: 'pass'
            };
            _this3.listLoading = true;

            _httpUtils.default.post("sendBox", "audit", null, parameter).then(function (res) {
              //let index;
              _this3.$message({
                message: _lang.default.t('warningMessage.auditSuccessMessage'),
                type: 'success'
              });

              _this3.handleFilter();
            }).catch(function (err) {
              _this3.$message({
                message: err.message,
                type: 'error'
              });
            }).finally(function () {
              _this3.listLoading = false;
            });
          });
        }

        if (status === "Refuse") {
          this.$prompt(_lang.default.t('warningMessage.refuseReasonConfirmMessage'), _lang.default.t('warningMessage.auditRecordMessage'), {
            confirmButtonText: _lang.default.t('common.confirm'),
            cancelButtonText: _lang.default.t('common.cancel')
          }).then(function (value) {
            for (var item in _this3.multipleSelection) {
              sendBoxIds.push(_this3.multipleSelection[item].id);
            }

            var parameter = {
              sendBoxIds: sendBoxIds,
              refuseCause: value.value,
              status: 'refuse'
            };
            _this3.listLoading = true;

            _httpUtils.default.post("sendBox", "audit", null, parameter).then(function (res) {
              //let index;
              _this3.$message({
                message: _lang.default.t('warningMessage.auditSuccessMessage'),
                type: 'success'
              });

              _this3.handleFilter();
            }).catch(function (err) {
              _this3.$message({
                message: err.message,
                type: 'error'
              });
            }).finally(function () {
              _this3.listLoading = false;
            });
          });
        }
      }
    },
    handleReacquireNotification: function handleReacquireNotification(val) {
      var _this4 = this;

      var orderNo = val.orderNo;

      _httpUtils.default.post("rechargeOrderNotify", "reacquireNotification", null, orderNo).then(function (res) {
        if (res.code == 200) {
          _this4.$notify({
            title: _lang.default.t('common.success'),
            message: _lang.default.t('rechargeOrderNotify.getRequestSent'),
            type: 'success',
            duration: 2000
          });
        }

        _this4.getList();
      }).catch(function (err) {
        _this4.$notify({
          title: _this4.$t("common.error"),
          message: _this4.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    convertNotifyType: function convertNotifyType(type) {
      if (!this.rechargeNotifyOption || !this.rechargeNotifyOption.length) return;
      var notifyType = this.rechargeNotifyOption.find(function (notifyType) {
        return notifyType.key === type;
      });

      if (notifyType) {
        return notifyType.display_name;
      } else {
        return "";
      }
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined || date == '-') {
        return "-";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    handleExportReport: function handleExportReport() {
      var excelName = _lang.default.t("route.orderNotifyReport") + ".xlsx";
      var params = this.getQueryParams(); // httpUtils.getByBlob("statisticalChannel", "excel", params, excelName);

      _httpUtils.default.getByBlob("rechargeOrderNotify", "excel", params, excelName); // MessageBox.confirm(
      //   i18n.t("warningMessage.pleaseWaitForExportAndNavigateMessage"),
      //   i18n.t("warningMessage.pleaseWaitForExportAndNavigateTitle"),
      //   {
      //     confirmButtonText: i18n.t("warningMessage.exportAndNavigateConfirmButtonText"),
      //     cancelButtonText: i18n.t("warningMessage.exportAndNavigateCancelButtonText"),
      //     type: 'warning'
      //   }
      // ).then(() => {
      //   // route to exported excel page
      //   this.$router.push({
      //     name: "exportedExcel:view"
      //   });
      // }).catch(() => null);

    }
  }
};
exports.default = _default;